import type { IAPI } from '../../apiResponse';
import { getRequest, type IRequestOptions } from '../../httpClient';
import {
  getPublicChallengeBySlugV6ResponseSchema,
  type IChallengeV6,
} from './get-public-challenge-by-slug-v6-response';

export async function getPublicChallengeBySlugV6Api(slug: string, options?: IRequestOptions) {
  return getRequest<IAPI<IChallengeV6>>({
    path: `/challenges/v6/slug/${encodeURIComponent(slug)}`,
    options,
    schema: getPublicChallengeBySlugV6ResponseSchema,
  });
}
